import React from "react";
import { Link } from "react-router-dom";
import { ArrowClockwise, Notebook, WarningCircle } from "@phosphor-icons/react";

export const BlogListSkeleton = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-loading" aria-busy="true">
    {[0, 1, 2, 3, 4, 5].map((i) => (
      <div key={i} className="rounded-[16px] border border-brand-border overflow-hidden">
        <div className="aspect-[16/9] mps-shimmer" />
        <div className="p-6 space-y-3">
          <div className="h-3 w-24 rounded mps-shimmer" />
          <div className="h-5 w-4/5 rounded mps-shimmer" />
          <div className="h-4 w-full rounded mps-shimmer" />
        </div>
      </div>
    ))}
  </div>
);

export const BlogPostSkeleton = () => (
  <div className="mps-container max-w-3xl py-16 md:py-20 space-y-5" data-testid="blog-post-loading" aria-busy="true">
    <div className="h-3 w-28 rounded mps-shimmer" />
    <div className="h-10 w-full rounded mps-shimmer" />
    <div className="h-10 w-2/3 rounded mps-shimmer" />
    <div className="aspect-[16/9] rounded-[16px] mps-shimmer mt-8" />
    {[0, 1, 2, 3].map((i) => <div key={i} className="h-4 w-full rounded mps-shimmer" />)}
  </div>
);

const StateShell = ({ testid, icon: Icon, title, children }) => (
  <div data-testid={testid} className="rounded-[16px] border border-dashed border-brand-border bg-brand-surface px-8 py-16 text-center">
    <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-white border border-brand-border mb-5">
      <Icon size={20} weight="regular" className="text-brand-accent" aria-hidden />
    </div>
    <h2 className="font-display text-2xl font-semibold tracking-tight text-brand-navy">{title}</h2>
    <div className="mt-3 text-brand-muted max-w-md mx-auto leading-relaxed">{children}</div>
  </div>
);

export const BlogEmpty = () => (
  <StateShell testid="blog-empty" icon={Notebook} title="No articles yet">
    <p>Our first research notes are on the way. In the meantime, browse the catalog or the COA library.</p>
    <Link to="/shop" data-testid="blog-empty-shop-link" className="inline-flex mt-6 h-11 items-center px-5 rounded-[12px] bg-brand-navy hover:bg-brand-navy2 text-white text-sm font-semibold transition-colors">
      Browse catalog
    </Link>
  </StateShell>
);

export const BlogError = ({ onRetry }) => (
  <StateShell testid="blog-error" icon={WarningCircle} title="Articles couldn't load">
    <p>Something went wrong while loading the blog. Please try again in a moment.</p>
    <button type="button" onClick={onRetry} data-testid="blog-retry-btn" className="inline-flex mt-6 h-11 items-center gap-2 px-5 rounded-[12px] border border-brand-border bg-white text-brand-navy hover:bg-brand-surface text-sm font-semibold transition-colors">
      <ArrowClockwise size={14} weight="bold" /> Try again
    </button>
  </StateShell>
);
